import { recipe } from "@vanilla-extract/recipes";
import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../theme/css/theme.css";
import { transition } from "../../utils/transition";
import { responsive, responsiveCard } from "../../utils/responsive";

export const containerBaseStyle = recipe({
  base: {
    position: "relative",
    transition: transition("background-color", "color", "border-color"),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    textAlign: "center",
    height: "100%",
    flexShrink: 0,
    flexGrow: 0,
    borderRadius: "var(--border-radius)",
  },
  variants: {
    size: {
      xxs: {
        width: rem(20),
        height: rem(20),
        vars: {
          "--border-radius": theme.borderRadiuses.xs2,
        },
      },
      xs: {
        width: rem(28),
        height: rem(28),
        vars: {
          "--border-radius": theme.borderRadiuses.xs2,
        },
      },
      s: {
        width: rem(36),
        height: rem(36),
        vars: {
          "--border-radius": theme.borderRadiuses.xs2,
        },
      },
      m: {
        width: theme.spacings.xl,
        height: theme.spacings.xl,
      },
      l: {
        width: theme.spacings.xl,
        height: theme.spacings.xl,
        ...responsive({
          s: {
            width: theme.spacings.xxl,
            height: theme.spacings.xxl,
          },
        }),
      },
      inline: {
        width: rem(40),
        height: rem(40),
        ...responsiveCard({
          300: {
            width: rem(46),
            height: rem(46),
          },
        }),
      },
    },
    inline: {
      true: {
        display: "inline-flex",
        verticalAlign: "middle",
      },
    },
    type: {
      rounded: {
        vars: {
          "--border-radius": "999px",
        },
      },
      square: {
        vars: {
          "--border-radius": theme.borderRadiuses.xs2,
        },
        ...responsiveCard({
          300: {
            vars: {
              "--border-radius": theme.borderRadiuses.s,
            },
          },
        }),
      },
    },
  },
  defaultVariants: {
    size: "m",
    type: "rounded",
  },
});

export const iconStyle = recipe({
  variants: {
    size: {
      xxs: {},
      xs: {},
      s: {},
      m: {},
      l: {},
      inline: {
        width: rem(18),
        height: rem(18),
        ...responsiveCard({
          300: {
            width: rem(22),
            height: rem(22),
          },
        }),
      },
    },
  },
});

export const containerVariantStyle = recipe({
  base: {
    border: "1px solid transparent",
    transition: transition("background-color", "color", "border-color"),
  },
  variants: {
    variant: {
      primary: {
        borderColor: theme.colors.primary,
        backgroundColor: theme.colors.primary,
        color: theme.colors.onPrimary,
      },
      secondary: {
        borderColor: theme.colors.secondary,
        backgroundColor: theme.colors.secondary,
        color: theme.colors.onSecondary,
      },
      gradient: {
        border: "none",
        background: `linear-gradient(110deg, ${theme.colors.gradientA} -5%, ${theme.colors.gradientB} 50%, ${theme.colors.gradientC} 105%)`,
        color: theme.colors.onPrimary,
      },
      tertiary: {
        borderColor: theme.colors.tertiary,
        backgroundColor: theme.colors.tertiary,
        color: theme.colors.onTertiary,
      },
      tertiarySurface: {
        borderColor: "transparent",
        backgroundColor: theme.colors.secondary,
        color: theme.colors.onSecondary,
      },
      accent: {
        borderColor: theme.colors.primary,
        backgroundColor: theme.colors.primary,
        color: theme.colors.onPrimary,
      },
      info: {
        borderColor: theme.colors.info,
        backgroundColor: theme.colors.info,
        color: theme.colors.onInfo,
      },
      infoSurface: {
        backgroundColor: theme.colors.infoSurface,
        color: theme.colors.info,
      },
      success: {
        borderColor: theme.colors.success,
        backgroundColor: theme.colors.success,
        color: theme.colors.onSuccess,
      },
      successSurface: {
        backgroundColor: theme.colors.successSurface,
        color: theme.colors.success,
      },
      warning: {
        borderColor: theme.colors.warning,
        backgroundColor: theme.colors.warning,
        color: theme.colors.onWarning,
      },
      warningSurface: {
        backgroundColor: theme.colors.warningSurface,
        color: theme.colors.warning,
      },
      error: {
        borderColor: theme.colors.error,
        backgroundColor: theme.colors.error,
        color: theme.colors.onError,
      },
      errorSurface: {
        backgroundColor: theme.colors.errorSurface,
        color: theme.colors.error,
      },
      currentColor: {
        backgroundColor: "currentColor",
        color: theme.colors.onPrimary,
        // ":before": {
        //   content: "''",
        //   position: "absolute",
        //   top: 0,
        //   left: 0,
        //   width: "100%",
        //   height: "100%",
        //   backgroundColor: "currentColor",
        //   opacity: 0.15,
        //   borderRadius: `var(--border-radius)`,
        // },
      },
      background: {
        backgroundColor: theme.colors.background,
        color: theme.colors.onBackground,
      },
    },
  },
  defaultVariants: {
    variant: "primary",
  },
});

export const borderedContainerStyle = recipe({
  base: {
    background: "transparent",
    border: "1px solid transparent",
  },
  variants: {
    variant: {
      primary: {
        borderColor: theme.colors.defaultBorder,
        color: theme.colors.primary,
      },
      secondary: {
        borderColor: theme.colors.secondary,
        color: theme.colors.secondary,
      },
      gradient: {
        borderColor: "transparent",
        background: `linear-gradient(110deg, ${theme.colors.gradientA} -5%, ${theme.colors.gradientB} 50%, ${theme.colors.gradientC} 105%)`,
        color: theme.colors.onPrimary,
      },
      tertiary: {
        borderColor: theme.colors.tertiary,
        color: theme.colors.tertiary,
      },
      tertiarySurface: {
        backgroundColor: theme.colors.secondary,
        color: theme.colors.secondary,
      },
      accent: {
        borderColor: theme.colors.primary,
        color: theme.colors.primary,
      },
      info: {
        borderColor: theme.colors.info,
        color: theme.colors.info,
      },
      infoSurface: {
        backgroundColor: theme.colors.infoSurface,
        color: theme.colors.onInfoSurface,
      },
      success: {
        borderColor: theme.colors.success,
        color: theme.colors.success,
      },
      successSurface: {
        backgroundColor: theme.colors.successSurface,
        color: theme.colors.onSuccessSurface,
      },
      warning: {
        borderColor: theme.colors.warning,
        color: theme.colors.warning,
      },
      warningSurface: {
        backgroundColor: theme.colors.warningSurface,
        color: theme.colors.onWarningSurface,
      },
      error: {
        borderColor: theme.colors.error,
        color: theme.colors.error,
      },
      errorSurface: {
        backgroundColor: theme.colors.errorSurface,
        color: theme.colors.onErrorSurface,
      },
      currentColor: {
        backgroundColor: "transparent",
        color: "currentColor",
      },
      background: {
        backgroundColor: theme.colors.background,
        color: theme.colors.onBackground,
      },
    },
  },
  defaultVariants: {
    variant: "primary",
  },
});

export const badgeStyle = style({
  transform: `translate(${rem(7)}, ${rem(-7)})`,
});
